import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ISingleQuoteLocationResponse, IUpdateQuoteLocationRequest } from "../models/Lead";
import apiConfig from "../utils/apiConfig";

export default function useQuoteLocationMutation(componentName = "useQuoteLocationMutation") {
  const { put } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const update = useMutation(
    ({
      leadId,
      quoteLocationId,
      quoteLocation,
    }: {
      leadId: string;
      quoteLocationId: string;
      quoteLocation: IUpdateQuoteLocationRequest;
    }) =>
      put<IUpdateQuoteLocationRequest, ISingleQuoteLocationResponse>(
        `/quoteLocation/${quoteLocationId}/by-lead/${leadId}`,
        quoteLocation
      ),
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(["quoteLocation", variables.quoteLocationId]);
        queryClient.invalidateQueries(["quoteLocation", "lead", variables.leadId]);
        queryClient.invalidateQueries(["lead", variables.leadId]);
        queryClient.invalidateQueries(["leads"]);
      },
    }
  );

  return {
    update,
  };
}
